import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const DefaultCompany = (props: SvgIconProps) => {
  const { color } = props

  const secondaryColor = color === 'primary' ? 'white' : 'black'
  const primary = color === 'secondary' ? '#fff' : color

  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    <SvgIcon width="47" height="47" viewBox="0 0 47 47" {...props}>
      <circle cx="23.6152" cy="23.1423" r="23" fill={primary} />
      <rect x="13.6152" y="14.1423" width="10" height="2" fill={secondaryColor} />
      <rect x="13.6152" y="18.1423" width="18.604" height="2" fill={secondaryColor} />
      <rect x="13.6152" y="30.1423" width="18.604" height="2" fill={secondaryColor} />
      <rect x="13.6152" y="22.1423" width="12" height="2" fill={secondaryColor} />
      <rect x="13.6152" y="26.1423" width="12" height="2" fill={secondaryColor} />
      <rect x="13.6152" y="30.1423" width="10" height="2" fill={secondaryColor} />
      <rect x="13.6152" y="32.1423" width="18" height="2" transform="rotate(-90 13.6152 32.1423)" fill={secondaryColor} />
      <rect x="17.6152" y="32.1423" width="18" height="2" transform="rotate(-90 17.6152 32.1423)" fill={secondaryColor} />
      <rect x="21.6152" y="32.1423" width="18" height="2" transform="rotate(-90 21.6152 32.1423)" fill={secondaryColor} />
      <rect x="31.6152" y="32.1423" width="14" height="2" transform="rotate(-90 31.6152 32.1423)" fill={secondaryColor} />
      <rect x="27.6152" y="22.1423" width="2" height="2" fill={secondaryColor} />
      <rect x="27.6152" y="26.1423" width="2" height="2" fill={secondaryColor} />
    </SvgIcon>
  )
}

export default DefaultCompany
